module.exports = __webpack_public_path__ + "img/left.f7a8b8ab.svg";